// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"557cfb49","626":"aae833ee","787":"fa13a416","906":"dcadd65b"}[chunkId] + ".chunk.js";
};